import BigNumber from 'bignumber.js';
import React from 'react';

import config from 'configs/app';
import useApiQuery from 'lib/api/useApiQuery';
import { useI18n } from 'lib/i18n/context';
import { currencyUnits } from 'lib/units';
import ChartWidget from 'ui/shared/chart/ChartWidget';

import { ADDRESS_LIST_KEYS } from '../i18n';

interface Props {
  addressHash: string;
}

const AddressCoinBalanceChart = ({ addressHash }: Props) => {
  const { t } = useI18n();
  const { data, isPending, isError } = useApiQuery('address_coin_balance_chart', {
    pathParams: { hash: addressHash },
  });

  const items = React.useMemo(() => {
    if (!data) {
      return undefined;
    }

    return data.items.map(({ date, value }) => ({
      date: new Date(date),
      value: BigNumber(value).div(10 ** config.chain.currency.decimals).toNumber(),
    }));
  }, [ data ]);

  return (
    <ChartWidget
      isError={ isError }
      title={ t(ADDRESS_LIST_KEYS.coinBalance.chartTitle) }
      items={ items }
      isLoading={ isPending }
      h="300px"
      units={ currencyUnits.ether }
      emptyText={ data?.days && t(ADDRESS_LIST_KEYS.coinBalance.insufficientData, { days: data.days }) }
    />
  );
};

export default React.memo(AddressCoinBalanceChart);
